import React from 'react';
import StyledButton from '../../../../shared/components/styledButton/styledButton';
import i18n from '../../../../utils/i18n';

const Navigation = ({
	handleBack,
	handleNext,
	step,
	disabledProp,
	backDisabledProp = false,
	onClickHandler,
	onClickHandlerFalse,
}) => {
	return (
		<div
			className={`SFButtonContainer ${
				step === 19 || step === 20 ? 'SFResultNavContainer' : ''
			}`}
			style={{
				justifyContent: 'space-between',
			}}>
			<div>
				<StyledButton
					className="btnMaxWidth130 Medium "
					color="NewNavBack"
					isDisabled={backDisabledProp}
					onClick={() => {
						step === 0
							? window.location.replace('https://www.bookkeepie.com/hu')
							: handleBack();
					}}>
					{step !== 0
						? i18n.t('general.backbutton')
						: i18n.t('providerdashboard.undo')}
				</StyledButton>

				{step === 19 && (
					<StyledButton
						className="btnMaxWidth130 Medium"
						color="NewNavBack"
						onClick={() => {
							onClickHandlerFalse();
						}}>
						{i18n.t('searchflow.sfresbuttontext2')}
					</StyledButton>
				)}
			</div>
			{step !== 19 && step !== 20 && (
				<StyledButton
					className="btnMaxWidth130 Medium"
					color="NewNavForward"
					onClick={() => {
						handleNext();
					}}
					isDisabled={disabledProp}>
					{i18n.t('general.forwardbutton')}
				</StyledButton>
			)}
			{step === 19 && (
				<StyledButton
					className="rfpButton"
					color="NewNavForward"
					onClick={() => {
						onClickHandler();
					}}
					isDisabled={disabledProp}>
					{i18n.t('searchflow.reqmsgtitle')}
				</StyledButton>
			)}
			{step === 20 && null}
		</div>
	);
};

export default Navigation;
